<template>
    <a href="#" @click.prevent @click="dropdownClick" :class="classes">
        <!-- <fa :icon="['fas', 'ellipsis']" /> -->
        <slot></slot>
    </a>
</template>

<script>
export default {
    name: 'AppDropDown',
    props: {
        classes: {
            type: String,
            default: '',
        },
    },
    emits: ['dropdownClick'],
    setup(props, context) {
        const dropdownClick = () => {
            context.emit('dropdownClick');
        }
        return {
            dropdownClick,
        }
    }
}
</script>

<style scoped>
.dropdown_btn {
    @apply text-green-500 text-2xl cursor-pointer;
}
.dropdown_btn__gray {
    @apply text-gray-300 text-2xl cursor-pointer;
}
</style>
